var _defs, _circle, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "id-back",
    "data-name": "ID Back",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 285 285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-back1{fill:#d1dced;}.cls-back2{fill:#eff5ff;}.cls-back3{fill:#6576ff;}.cls-back4{fill:#fff;}.cls-back5{fill:#b4c4db;}.cls-back6{opacity:0.4;}.cls-back7{fill:#a3b5d1;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-back1",
    cx: 142.5,
    cy: 142.5,
    r: 106
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-back2",
    d: "M27.54,228.88A6.55,6.55,0,0,1,21,222.33l0-147.9a6.45,6.45,0,0,1,1-3.56,6.54,6.54,0,0,1,5.5-3l216.81.06a6.55,6.55,0,0,1,6.55,6.54l0,147.91a6.54,6.54,0,0,1-6.55,6.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-back3",
    d: "M263.45,214.57a6.57,6.57,0,0,0,1.36-4l0-147.91a6.55,6.55,0,0,0-6.55-6.55l-216.81,0a6.54,6.54,0,0,0-5.5,3,6.44,6.44,0,0,0-1.05,3.55l0,147.91a6.55,6.55,0,0,0,6.55,6.55,7.55,7.55,0,0,0-.83.05H258.28A6.55,6.55,0,0,0,263.45,214.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-back4",
    d: "M259.63,62.66l0,147.9a1.32,1.32,0,0,1-1.32,1.34l-216.82-.06a1.31,1.31,0,0,1-1-.48,1.29,1.29,0,0,1-.31-.85l0-147.91a1.32,1.32,0,0,1,.21-.72,1.37,1.37,0,0,1,1.11-.6l216.83,0a1.29,1.29,0,0,1,1,.44A1.34,1.34,0,0,1,259.63,62.66Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-back5",
    x: 64.01,
    y: 81.86,
    width: 154.2,
    height: 3.09
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-back5",
    x: 64.01,
    y: 95.51,
    width: 98.98,
    height: 3.09
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-back5",
    x: 64.01,
    y: 109.15,
    width: 46.15,
    height: 3.09
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-back5",
    x: 64.01,
    y: 175.8,
    width: 46.15,
    height: 3.09
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-back5",
    x: 64.01,
    y: 158.84,
    width: 71.96,
    height: 8.31
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-back6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-back7",
    d: "M217.12,165.35V162a17.33,17.33,0,0,0,0-34.66v-3.39a20.72,20.72,0,0,1,0,41.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-back7",
    d: "M217.12,154.32a9.7,9.7,0,0,1-9.68-9.69,9.55,9.55,0,0,1,.76-3.77l3.11,1.32a6.41,6.41,0,0,0-.49,2.45,6.3,6.3,0,1,0,12.6,0h3.38A9.7,9.7,0,0,1,217.12,154.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-back7",
    d: "M217.09,165.34a20.71,20.71,0,0,1-17.91-31.07l2.93,1.69a17.33,17.33,0,1,0,30,17.34l2.93,1.69A20.72,20.72,0,0,1,217.09,165.34Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdBack);
export default __webpack_public_path__ + "static/media/id-back.e3eb82b02034d67051a02e09b6be513e.svg";
export { ForwardRef as ReactComponent };